import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService, LoadingService } from 'ngx-kuv-tools';
import { EmpresaService } from 'src/app/components/empresa/empresa.service';
import { FormatterService } from 'src/app/utils/formatter/formatter.service';
import { SesionService } from 'src/app/utils/sesion/sesion.service';

@Component({
  selector: 'app-formulario-facturacion-electronica',
  templateUrl: './formulario-facturacion-electronica.component.html',
  styleUrls: ['./formulario-facturacion-electronica.component.scss']
})
export class FormularioFacturacionElectronicaComponent implements OnInit {
  /*   @Input() empresa: any; */
  form: FormGroup = new FormGroup({});
  certificado: any;
  certificadoError: boolean = false;
  constructor(
    public formBuilder: FormBuilder,
    private loading: LoadingService,
    private alerts: AlertService,
    public activeModal: NgbActiveModal,
    public formatter: FormatterService,
    private empresaService: EmpresaService,
    private sesion: SesionService,

  ) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      rut: [null],
      nombre_o_razonSocial: [null, Validators.required],
      empresa_id: [this.sesion.empresaID],
      giro_comercial: [null],
      actividades_economicas: [null],
      region: [null, Validators.required],
      ciudad: [null, Validators.required],
      comuna: [null, Validators.required],
      direccion_comercial: [null, Validators.required],
      correo_electronico_comercial: [null, [Validators.required, Validators.email]],
      nombre_apellido_representante_legal: [null, Validators.required],
      rut_representante_legal: [null, Validators.required],
      correo_electronico_representante_legal: [null, [Validators.required, Validators.email]],

    })

  }

  cargarCertificado(event: any) {
    const file = event.target.files[0];
    if (!file) {
      this.certificadoError = true;
      return;
    }
    this.certificadoError = false;
    this.certificado = file;
  }

  guardar() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.loading.show();
    const data = this.form.value;
  
    this.empresaService.guardarFormulario(data, this.certificado).subscribe({
      next: (res: any) => {
        this.loading.hide();
        this.alerts.addAlert('Formulario guardado correctamente', 'success');
      }, error: (err: any) => {
        this.loading.hide();
        if (err.response) this.alerts.addAlert(err.response, 'danger');
        if (err.error.response) this.alerts.addAlert(err.error.response, 'danger')
        if (err.error.msg) this.alerts.addAlert(err.error.msg, 'danger');
      }
    });
  }
}
